import axiosInstance from '../utils/axios';

const CANTEEN_API_BASE = '/api/students';

export const canteenService = {
  // Get canteen payment status for a specific date
  async getCanteenStatus(schoolID, date, class_ = '') {
    try {
      const response = await axiosInstance.post(`${CANTEEN_API_BASE}/getcanteenstatus`, {
        schoolID,
        date,
        class_
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching canteen status:', error);
      throw error;
    }
  },

  // Update canteen payment status
  async updateCanteenStatus(schoolID, studentID, date, status) {
    try {
      const response = await axiosInstance.post(`${CANTEEN_API_BASE}/updatecanteenstatus`, {
        schoolID,
        studentID,
        date,
        status
      });
      return response.data;
    } catch (error) {
      console.error('Error updating canteen status:', error);
      throw error;
    }
  },

  // Get canteen payment history for a student
  async getCanteenHistory(schoolID, studentID) {
    try {
      const response = await axiosInstance.get(`${CANTEEN_API_BASE}/canteenhistory`, {
        params: {
          schoolID,
          studentID
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching canteen history:', error);
      throw error;
    }
  },

  // Bulk update canteen status for multiple students
  async bulkUpdateCanteenStatus(schoolID, updates) {
    try {
      const response = await axiosInstance.post(`${CANTEEN_API_BASE}/bulkupdatecanteenstatus`, {
        schoolID,
        updates
      });
      return response.data;
    } catch (error) {
      console.error('Error bulk updating canteen status:', error);
      throw error;
    }
  },

  // Get canteen statistics
  async getCanteenStats(schoolID, date) {
    try {
      const response = await axiosInstance.get(`${CANTEEN_API_BASE}/canteenstats`, {
        params: {
          schoolID,
          date
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching canteen stats:', error);
      throw error;
    }
  },

  // Process canteen payments for multiple students
  async processPayments(paymentData, schoolID, status) {
    try {
      const response = await axiosInstance.post(`${CANTEEN_API_BASE}/paycanteen`, {
        data: paymentData,
        schoolID: schoolID,
        status: status
      });

      
      return {
        success: true,
        data: response.data,
        message: `Successfully processed ${paymentData.length} canteen payments`,
        count: paymentData.length
      };
    } catch (error) {
      console.error('❌ Error processing canteen payments:', error);
      
      // Enhanced error handling
      let errorMessage = "Error processing canteen payments";
      let errorDetails = {};
      
      if (error.response) {
        // Server responded with error status
        errorDetails = {
          status: error.response.status,
          data: error.response.data,
          message: error.response.data?.message || error.message
        };
        
        if (error.response.status === 500) {
          errorMessage = "Server error while processing payments. Please try again.";
        } else if (error.response.status === 400) {
          errorMessage = "Invalid payment data. Please check the amounts and try again.";
        } else if (error.response.status === 404) {
          errorMessage = "Payment endpoint not found. Please contact support.";
        }
      } else if (error.request) {
        // Network error
        errorMessage = "Network error. Please check your connection and try again.";
        errorDetails = {
          message: "No response received from server",
          url: error.config?.url
        };
      } else {
        // Other error
        errorMessage = error.message || "Unknown error occurred";
        errorDetails = {
          message: error.message,
          stack: error.stack
        };
      }
      
      throw {
        message: errorMessage,
        details: errorDetails,
        originalError: error
      };
    }
  },

  // Process bulk payments for multiple dates
  async processBulkMultiDatePayments(paymentData, schoolID, status, dates) {
    try {
      const response = await axiosInstance.post(`${CANTEEN_API_BASE}/paycanteen`, {
        data: paymentData,
        schoolID: schoolID,
        status: status,
        dates: dates // Array of dates for bulk processing
      });

      return {
        success: true,
        data: response.data,
        message: `Successfully processed bulk payments for ${paymentData.length} students across ${dates.length} dates`,
        totalStudents: paymentData.length,
        totalDates: dates.length,
        totalTransactions: paymentData.length * dates.length
      };
    } catch (error) {
      console.error('❌ Error processing bulk multi-date payments:', error);

      // Enhanced error handling
      let errorMessage = "Error processing bulk multi-date payments";
      let errorDetails = {};

      if (error.response) {
        errorDetails = {
          status: error.response.status,
          data: error.response.data,
          message: error.response.data?.message || error.message
        };

        if (error.response.status === 500) {
          errorMessage = "Server error while processing bulk payments. Please try again.";
        } else if (error.response.status === 400) {
          errorMessage = "Invalid bulk payment data. Please check the amounts and dates.";
        } else if (error.response.status === 404) {
          errorMessage = "Bulk payment endpoint not found. Please contact support.";
        }
      } else if (error.request) {
        errorMessage = "Network error. Please check your connection and try again.";
        errorDetails = {
          message: "No response received from server",
          url: error.config?.url
        };
      } else {
        errorMessage = error.message || "Unknown error occurred";
        errorDetails = {
          message: error.message,
          stack: error.stack
        };
      }

      throw {
        message: errorMessage,
        details: errorDetails,
        originalError: error
      };
    }
  }
};
